import { createSelector } from '@ngrx/store';
import { IChannelsModel } from '@partners/api';
import { IRootState } from '../../../root';
import { IChannelsState } from './channels.state';

export class ChannelsSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly channelsState = (state: IRootState): IChannelsState => {
    return state.channels as IChannelsState;
  };

  static readonly model = createSelector(ChannelsSelectors.channelsState, (channels: IChannelsState) => {
    return channels.model;
  });

  static readonly channels357Model = createSelector(ChannelsSelectors.model, (channelsModel: IChannelsModel) => {
    return channelsModel.banking?.channel357;
  });

  static readonly spamModel = createSelector(ChannelsSelectors.model, (channelsModel: IChannelsModel) => {
    return channelsModel.banking?.spam;
  });

  static readonly upSaleModel = createSelector(ChannelsSelectors.model, (channelsModel: IChannelsModel) => {
    return channelsModel.banking?.upsales;
  });

  static readonly data = createSelector(ChannelsSelectors.channelsState, (channels: IChannelsState) => {
    return channels.data;
  });
}
